// removed by extract-text-webpack-plugin
module.exports = {"block":"_1MZ-xr28-8mUSeIAcC8bbO","header":"_3OSkwiPcKs4huNtue2FcIm","block-heading":"_1hIiuktCiWfuktR86CziaB","block-intro":"_2mG06ytrQD84UVbFUitUy3","condensed":"UeYeYCu9w3BJm_9N4lfJN","videos":"_1Rjd29OgH8V9XBg9jU0QIU","playing":"zil55q6cyE4EnzuGJ6Taf","video":"GTlZgu9odjWoZad6RTtBs","preview":"_1tk2jMkwVWk4VhLPco4V4L","squared":"bQWjjTzXG1wG5F2ZW4zT9","active":"_1TuxH4fwrJ_zTQn2DpOhdS","subtitle":"_3DYwEYTBxLq9WjyAddKAb5","description":"_2XEJ_G7ca3viFEybCL5H9x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VideoListBlock/VideoListBlock.module.scss
// module id = 815
// module chunks = 0